import React, { useEffect, useState } from "react";
import { Box, Typography, Card, CardContent, CircularProgress, Button, Container } from "@mui/material";
import { backendServerUrl } from "../config";

const FeedbackSection = () => {
  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await fetch(`${backendServerUrl}/api/feedback/all`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch feedback");
        }
        const data = await response.json();
        setFeedback(data);
      } catch (error) {
        console.error("Error fetching feedback:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeedback();
  }, []);

  const handleUpvote = async (feedbackId) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${backendServerUrl}/api/feedback/upvote`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ feedbackId }),
      });

      if (!response.ok) {
        throw new Error("Failed to upvote feedback");
      }

      const data = await response.json();
      setFeedback((prevFeedback) =>
        prevFeedback.map((item) =>
          item.id === feedbackId ? { ...item, votes: data.votes } : item
        )
      );
    } catch (error) {
      console.error("Error upvoting feedback:", error);
    }
  };

  const handleDelete = async (feedbackId) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${backendServerUrl}/api/feedback/${feedbackId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to delete feedback");
      }

      setFeedback((prevFeedback) =>
        prevFeedback.filter((item) => item.id !== feedbackId)
      );
    } catch (error) {
      console.error("Error deleting feedback:", error);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "50vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container id="featuresSection" maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom color="primary">
        Submitted Feedback
      </Typography>
      {feedback.length === 0 ? (
        <Typography>No feedback available.</Typography>
      ) : (
        feedback.map((item) => (
          <Card key={item.id} sx={{ marginBottom: 2 }}>
            <CardContent>
              <Typography variant="h6">{item.email}</Typography>
              <Typography variant="body1" color="text.secondary">
                {item.created_at}
              </Typography>
              <Typography variant="body1" sx={{ marginTop: 1 }}>
                {item.feedback_text}
              </Typography>
              <Typography variant="body1" sx={{ marginTop: 1 }}>
                Votes: {item.votes}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleUpvote(item.id)}
                sx={{ marginTop: 1, marginRight: 1 }}
              >
                Upvote
              </Button>
              {(item.email === localStorage.getItem("authTokenEmail") ||
                localStorage.getItem("authTokenEmail") === "admin@rekono.at") && (
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => handleDelete(item.id)}
                  sx={{ marginTop: 1 }}
                >
                  Delete
                </Button>
              )}
            </CardContent>
          </Card>
        ))
      )}
    </Container>
  );
};

export default FeedbackSection;
